// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeAwardCustomArchiveBody = {
  poolId: string;
  awardTypeId: string;
  announce?: boolean | null;
};

export type typeAwardCustomArchiveOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { awardTypeId: string; status: "archived"; announced: boolean };
};

export type typeAwardCustomArchiveOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeAwardCustomArchiveOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeAwardCustomArchiveOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaAwardCustomArchiveBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    awardTypeId: { type: "string", maxLength: 3000, minLength: 1 },
    announce: { oneOf: [{ type: "boolean" }, { enum: [null] }] },
  },
  required: ["poolId", "awardTypeId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createAwardCustomArchive(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaAwardCustomArchiveBody);
  }

  return async function postAwardCustomArchive(
    payload: typeAwardCustomArchiveBody,
  ): Promise<
    typeAwardCustomArchiveOutput200 | typeAwardCustomArchiveOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postAwardCustomArchive" failed before calling the network. #5a19e9136101`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#5a19e9136101" },
        },
        data: null,
      } as typeAwardCustomArchiveOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/award/custom-archive`,
      httpMethod: "POST",
      options,
    })) as typeAwardCustomArchiveOutput200 | typeAwardCustomArchiveOutput400;
  };
}
